module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.maintenanceMode) ? _c('div', [_vm._v("rmCloud is currently under maintenance.  Please check back soon!")]) : _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02b1ad9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 991
// module chunks = 1